import React from 'react';
import { connect } from 'react-redux';
import { Tag, useIsMobileDimension } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { DEVICE_CARD_SIZE } from "../../../../store/blocks/constants";
import { getDeviceCardSize, getDeviceColor, getDeviceTags } from "../../../../store/blocks/devices/selectors";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _DeviceCardContent = function _DeviceCardContent(_ref) {
  var children = _ref.children,
    tags = _ref.tags,
    withTag = _ref.withTag;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: cx('content'),
    "data-t-id": "components-DeviceCardContent"
  }, withTag && !isMobile && /*#__PURE__*/React.createElement("div", null, tags.map(function (_ref2) {
    var color = _ref2.color,
      text = _ref2.text;
    return /*#__PURE__*/React.createElement(Tag, {
      key: text,
      variant: color
    }, text);
  })), children);
};
_DeviceCardContent.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  tags: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string,
    text: PropTypes.string
  })),
  withTag: PropTypes.bool
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    cardColor: getDeviceColor(state),
    tags: getDeviceTags(state),
    withTag: getDeviceCardSize(state) !== DEVICE_CARD_SIZE.small
  };
};
export var DeviceCardContent = connect(mapStateToProps)(_DeviceCardContent);